<template>
    <div
        :class="
            twMerge(
                'slt-flex-center slt-max-content-center slt-padding-box flex-col gap-6  sm:gap-10  lg:gap-12 lg:px-[min(10vw,200px)]',
                page === 'awards' ? 'mt-12 lg:mt-[72px]' : 'mt-20 sm:mt-40',
            )
        "
    >
        <div
            class="flex w-full flex-col gap-6 sm:flex-row sm:items-center sm:justify-between sm:gap-[unset]"
        >
            <AtomsH3
                class="text-base-black"
                v-if="page === 'news' && shouldRender(title)"
            >
                {{ renderLines(title) }}
            </AtomsH3>

            <div
                class="ml-auto flex w-full items-center justify-center gap-[2.03vw] rounded-full xs:gap-[8px] sm:max-w-[450px] lg:w-[77.51%] lg:max-w-[820px] lg:gap-4"
            >
                <InputSearch
                    variant="light"
                    :placeholder="t('toolbar.search.placeholder.news')"
                    @update:keyword="
                        (keyword) => {
                            handleSearchChange(
                                keyword,
                                page === 'news' ? 'news' : 'award',
                            );
                            searchTracking(keyword);
                        }
                    "
                    @cancelSearch="handleCancelSearch"
                    class="lg:h-full"
                />
                <InputSelect
                    selectId="idFilter"
                    type="filter"
                    variant="light"
                    useIconOnTablet
                    :config="filterOptions"
                    @change="handleFilterChange"
                    class="lg:max-w-[150px]"
                />
                <InputSelect
                    selectId="idSort"
                    type="sort"
                    variant="light"
                    useIconOnTablet
                    :config="sortOptions"
                    @change="handleSortChange"
                    class="lg:max-w-[150px]"
                />
                <DatePicker
                    v-model="state.selectedDate"
                    @clear="handleDateClear"
                />
            </div>
        </div>
        <div v-if="state.isPending" class="flex justify-center py-[200px]">
            <div class="slt-bouncing w-[60px]">
                <GamaGlobeLottie />
            </div>
        </div>
        <ul
            class="flex w-full flex-col items-stretch justify-center gap-6"
            v-else-if="shouldRender(state.shownPosts)"
        >
            <li v-for="(h, idx) in state.shownPosts" :key="idx">
                <MoleculesNews :news="h" :page="page" :search="state.search" />
            </li>
        </ul>
        <!-- If no result, show no result message and fast link -->
        <div v-else class="w-full">
            <AtomsH3 class="py-[100px] text-base-black">
                {{ t("news.post.noResult") }}
            </AtomsH3>
            <MoleculesFastLinks />
        </div>
    </div>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
import { renderLines, shouldRender } from "~/lib/utils";
import { usePostsContext } from "@/composables/usePostsContext";
import DatePicker from "@/components/molecules/datePicker/DatePicker.vue";
import { useGtag } from "vue-gtag-next";

const { t } = useI18n();
const { event } = useGtag();
const { page, title } = defineProps({
    page: {
        type: String,
        default: "news",
    },
    title: {
        type: Array,
        default: () => [],
    },
});

const {
    state,
    filterOptions,
    sortOptions,
    handleSearchChange,
    handleCancelSearch,
    handleFilterChange,
    handleSortChange,
    handleDateClear,
} = usePostsContext();

const searchTracking = (keyword) => {
    event("search", {
        search_term: keyword.trim(),
        event_category: page === "news" ? "news" : "awards",
        event_label: "search",
    });
};
</script>
